The identifier for the draft that the `PositionProfile` to be posted from.
